import { render, staticRenderFns } from "./selectvatregime.vue?vue&type=template&id=270bc2d0&"
import script from "./selectvatregime.js?vue&type=script&lang=js&"
export * from "./selectvatregime.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270bc2d0')) {
      api.createRecord('270bc2d0', component.options)
    } else {
      api.reload('270bc2d0', component.options)
    }
    module.hot.accept("./selectvatregime.vue?vue&type=template&id=270bc2d0&", function () {
      api.rerender('270bc2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectvatregime.vue"
export default component.exports